function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M0 8.00006C0 11.0324 1.68719 13.6705 4.17391 15.0273V0.972778C1.68719 2.32959 0 4.96772 0 8.00006Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M15.5024 10.7827C15.824 9.91606 16 8.97869 16 8.00012C16 7.02156 15.824 6.08415 15.5024 5.21753H0.497625C0.176031 6.08415 0 7.02156 0 8.00012C0 8.97869 0.176031 9.91606 0.497625 10.7827L8 11.4784L15.5024 10.7827Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M7.99993 16C11.4397 16 14.372 13.829 15.5024 10.7826H0.497559C1.62787 13.829 4.56025 16 7.99993 16Z",
  fill: "#6DA544"
}), React.createElement("path", {
  d: "M0 8.00004C0 11.6963 2.50691 14.8064 5.91303 15.7244V0.275635C2.50691 1.19363 0 4.30382 0 8.00004Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M4.89406 3.52044L4.15622 2.78259L3.66435 3.27453L3.17247 2.78259L2.43463 3.52044L2.92654 4.01234L2.43457 4.50428L3.17241 5.24212L3.66432 4.75019L4.15622 5.24212L4.89406 4.50428L4.40216 4.01234L4.89406 3.52044Z",
  fill: "#F0F0F0"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgOman = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgOman, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/oman.e863bf72.svg";
export { ForwardRef as ReactComponent };